exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.link[data-v-5f813f48]:hover {\n  text-decoration: underline;\n  cursor:pointer;\n}\n.spacer[data-v-5f813f48] {\n  margin-top: 60px;\n  margin-bottom: 60px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f813f48","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/statistics/components/CashFlow/CashStats.vue
// module id = 1602
// module chunks = 2